var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerified = function SvgVerified(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 16C9.30058 16 10.3409 15.7931 11.3115 15.391C12.2821 14.989 13.164 14.3997 13.9069 13.6569C14.6497 12.914 15.239 12.0321 15.641 11.0615C16.0431 10.0909 16.25 9.05058 16.25 8C16.25 6.94943 16.0431 5.90914 15.641 4.93853C15.239 3.96793 14.6497 3.08601 13.9069 2.34315C13.164 1.60028 12.2821 1.011 11.3115 0.608964C10.3409 0.206926 9.30058 -1.56548e-08 8.25 0C6.12827 3.16163e-08 4.09344 0.842855 2.59315 2.34315C1.09285 3.84344 0.25 5.87827 0.25 8C0.25 10.1217 1.09285 12.1566 2.59315 13.6569C4.09344 15.1571 6.12827 16 8.25 16ZM8.04378 11.2356L12.4882 5.90222L11.1229 4.76444L7.30067 9.35022L5.32289 7.37156L4.066 8.62844L6.73267 11.2951L7.42067 11.9831L8.04378 11.2356Z",
    fill: "#19AF00"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Verified.bcf05a587c879facbb2855b5a6e5741c.svg";